import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import ServerService from "../../api/serverService";
import {setApplicationError} from "./Slice";
import CfgAttributeService from "../../api/cfgAttributeService";
import {CfgAttributesNames} from "../../util/constants";

export const getServerTime =
    createAsyncThunk(`${SliceNames.APP}/getServerTime`,
        async (_, thunkAPI) => {
            try {
                const res = await ServerService.fetchServerTime()
                return res.data.server_time_now
            } catch (e: any) {
                thunkAPI.dispatch(
                    setApplicationError({isError: true, statusCode: undefined})
                )
                return thunkAPI.rejectWithValue(e)
            }
        })

export const getFeatureToggles =
    createAsyncThunk(`${SliceNames.APP}/getFeatureToggles`,
        async (_, thunkAPI) => {
            try {
                const res = await CfgAttributeService.fetchAttributeValue(CfgAttributesNames.FEATURE_TOGGLES)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })